import _ from 'underscore';
import { FlyerAdExtension } from '@bingads-webui-campaign/campaign-ui-schemas';
import { panelDecorator } from '@bingads-webui-campaign-react/panel-decorator';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import dialogDecorator from '@bingads-webui-component-legacy/dialog/dialogDecorator';
// This i18n use {0} for template
// This i18n use {{prop_name}} for template
import SchedulingView from '@bingads-webui-campaign-legacy/adextension-shared/view/scheduling';
import AssociationsEditorBase from '@bingads-webui-campaign-legacy/adextension-associations-editor/view/index';
import _SharedRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';

const $i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');
const legacyI18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/adextensions');

const SharedRepository = _SharedRepository.default || _SharedRepository;

const dialogOptions = { position: 'center', maxWidth: 1000 };

/* eslint-disable camelcase */
const i18nKeys = {
  title: 'AdExtensions_Flyer_Editor_Title',
  subtitle: ['NewCampaign_FlyerAdExtension_Subtitle'],
  library_title: 'AdExtensions_Flyer_Editor_Available',
  selected_title: 'AdExtensions_Flyer_Editor_Selected',
  create_link: 'AdExtensions_Flyer_Editor_CreateNew',
  create_title: 'AdExtensions_Flyer_Dialog_Title_Add',
  delete_btn: 'AdExtensions_Flyer_Editor_Delete',
  delete_confirm: 'AdExtensions_Flyer_Delete_Warning',
  edit_btn: 'AdExtensions_Flyer_Editor_Edit',
  edit_title: 'AdExtensions_Flyer_Dialog_Title_Edit',
  inlineAlert: 'AdExtensions_Flyer_Max_Select_Notification',
};
/* eslint-enable camelcase */

const defaultRepositoryFactory = function (factoryOptions) {
  const { schema, updateContext } = factoryOptions;

  return new SharedRepository({
    schema,
    afterChangeComitted() {
      if (_.isFunction(updateContext)) {
        updateContext(['AccountAdExtensionsGrid', 'CampaignAdExtensionsGrid', 'AdGroupAdExtensionsGrid']);
      }
    },
  });
};

const FlyerAssociationEditor = AssociationsEditorBase.extend({
  initialize(options) {
    const EditorView = options.vnextContext.dynamicFeatures.DynamicFlyerExtensionEditor;
    const Editor = options && options.usePanel ? panelDecorator(EditorView,
      {
        i18n: $i18n,
        panelReadyAriaLabel: $i18n.getString('Association editor side panel opened'),
        panelClassName: options.panelClassName,
      }) :
      dialogDecorator.decorate(EditorView, dialogOptions);
    const repositoryFactory = options.repositoryFactory || defaultRepositoryFactory;

    _.extend(options, {
      idField: 'Id',
      data: repositoryFactory({
        schema: FlyerAdExtension,
        updateContext: options.updateContext,
      }),
      template: {
        previewTemplateType: 'function',
        preview: options.vnextContext.dynamicFeatures.universalItemTemplate,
        rowTemplate: options.vnextContext.dynamicFeatures.universalItemTemplate,
      },
      extensionType: 'FlyerExtension',
      maxSelectedItemsCount: options.maxSelectedItemsCount || 3,
      CreateForm: Editor,
      EditForm: Editor,
      extraEditorOptions: {
        legacyI18n,
        deps: {
          SchedulingView,
          odata,
          jsdata,
        },
      },
      i18nKeys: _.extend({}, i18nKeys, options.i18nKeys || {}),
    });
    AssociationsEditorBase.prototype.initialize.apply(this, [options]);
  },
});

export default FlyerAssociationEditor;
